"use client";

import React, { useEffect, useState } from "react";
import { Facebook, Instagram, MapPin, Phone, Clock, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors">Diensten</Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors">Over Ons</Link>
        </li>
        <li data-index={2}>
          <Link to="/ContactPage" className="text-muted-foreground hover:text-primary transition-colors">Contact</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const checkOpenStatus = () => {
      const now = new Date();
      const day = now.getDay();
      const hour = now.getHours();
      if (day >= 1 && day <= 5 && hour >= 9 && hour < 18) {
        setIsOpen(true);
      } else if (day === 6 && hour >= 9 && hour < 16) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };
    checkOpenStatus();
    const interval = setInterval(checkOpenStatus, 60000);
    return () => clearInterval(interval);
  }, []);
  return <section id="footer" className="dark bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-7 w-auto" />
            </Link>
            <p className="text-muted-foreground leading-relaxed">
              De ultieme barbierservaring in Middelharnis. H&E Kappers combineert sinds 2010 vakmanschap met moderne trends voor de modebewuste man.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-lg font-bold text-foreground font-serif mb-6 tracking-wide">Snelle Links</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-lg font-bold text-foreground font-serif mb-6 tracking-wide">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-muted-foreground">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>
                  Zandpad 2<br />
                  3241 GX Middelharnis<br />
                  Nederland
                </span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground">
                <Phone className="size-5 text-primary shrink-0" />
                <Link to="tel:+31639394199" className="hover:text-primary transition-colors">
                  +31 6 39394199
                </Link>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground">
                <Mail className="size-5 text-primary shrink-0" />
                <Link to="mailto:info@hekappers.nl" className="hover:text-primary transition-colors">
                  info@hekappers.nl
                </Link>
              </li>
            </ul>
          </div>

          {}
          

        </div>

        {}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} H&E Kappers. Alle rechten voorbehouden.
          </p>
          <div className="flex items-center gap-4">
            <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}